import { Services } from '@/infra/services';
import { type Response } from '@/infra/services/checkout/cart/get-cart-cashbacks';

export async function getCartCashbacks(): Promise<Response> {
  return await Services.Checkout.Cart.getCartCashbacks();
}
